import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import RichTextEditor from 'Components/UI/RichTextEditor';
import { SearchableSelect } from 'Components/UI/Select/SearchableSelect';
import DateFieldStandardized from 'Components/ComponentLibrary/Components/Uncategorized/DateField';

const hiddenFieldNames = [
  'hidden',
  'ownerName',
  'clientName',
  'completedAt',
  'leadPlannerName',
  'householdId',
  'ownerType',
  'actionItemType',
  'createdAt',
  'createdByName',
];

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride(name => hiddenFieldNames.includes(name), { hidden: true })
  .nameOverride('description', {
    _component: () => RichTextEditor,
    _customProps: {
      size: 'sm',
    },
  })
  .nameOverride('dueDate', {
    _component: () => DateFieldStandardized,
    _customProps: {
      format: 'MM/DD/YYYY',
      placeholder: 'MM/DD/YYYY',
    },
  })
  .nameOverride('assignedTo', { _component: () => SearchableSelect });
